import React from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {category} from '../config/category';
import {connect} from "react-redux";
import {setCurrentLocation} from "../store/actions/action";
import axios from "axios";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import AlibabaAds from "./Ads/AlibabaAds";
import AmazonAds from "./Ads/AmazonAds";
import {Helmet} from "react-helmet";
import {Box, Carousel, Text} from "grommet";
import {Deploy} from "grommet-icons";

const currentUser = JSON.parse(localStorage.getItem('UserObject'));

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            category: [],
            place: '',
            trending: '',
            location: ''
        };
    }

    componentDidMount() {
        this.getTrends();
        this.setState({category: category})

        let input = document.getElementById('location');
        let options = {
            types: ['(cities)'],
            // componentRestrictions: {country: "uk"}
        };
        let autoComplete = new window.google.maps.places.Autocomplete(input, options);
        autoComplete.addListener('place_changed', () => {
            let place = autoComplete.getPlace();

            const upper = this.capital(place.name);
            let location = {
                city: place.name,
                country: place.address_components[4] ? place.address_components[4].long_name
                    : place.address_components[3].long_name
            };
            this.props.setLocation(location);
            localStorage.setItem('location', JSON.stringify(location));
            this.props.history.push('/cities/' + upper);
            // console.log(upper);
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log('next->', nextProps);
        this.getTrends();
    }

    capital = (str) => {
        let splitStr = str.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }
    getTrends = () => {
        const location = JSON.parse(localStorage.getItem('location'));
        this.setState({location})
        let url = `${process.env.REACT_APP_BACKEND_URL}/item/trending`;
        if (!location)
            url = url + '?country=United Kingdom'
        if (location && location.city)
            url = url + '?city=' + location.city;

        axios.get(url)
            .then((res) => {
                this.setState({trending: res.data});
            }).catch(err => console.error(err))
    }

    render() {
        const {trending, location, category} = this.state;
        let cates = category.map(a => {
            return a.cate;
        });
        return (
            <React.Fragment>
                <Helmet
                    // titleTemplate="euBines.com"
                >
                    <title>euBines.com</title>
                    <meta name="description"
                          content={"euBines.com: Buy and sell something. Use euBines.com to find the products and offers of today."}/>
                    <meta name="keywords"
                          content={`euBines.com: Buy and sell something. Use euBines.com to find the products and offers of today. ${cates.length > 0 ? cates : 'Phones, Clothes, Cosmetic and Beauty.'} `}/>
                    <link rel="canonical" href="https://www.euBines.com"/>

                    <meta name="mobile-web-app-capable" content="yes"/>
                    <meta name="theme-color" content="#fff"/>
                    <meta name="application-name" content="euBines"/>

                    <meta property="og:type" content="website"/>
                    <meta property="og:site_name" content="euBines.com"/>
                    <meta property="og:title"
                          content={`euBines.com ${location && location.city ? location.city : 'United Kingdom'} | Free Classifieds Ads and Offers`}/>
                    <meta property="og:country-name"
                          content={`${location && location.country ? location.country : 'United Kingdom'}`}/>
                    <meta property="og:region" content={`${location && location.city ? location.city : 'London'}`}/>
                    <meta property="og:locality" content={`${location && location.city ? location.city : 'London'}`}/>

                    <meta property="fb:page_id" content="382391225699581"/>

                    <meta name="twitter:site" content="@eubinesdotcom"/>
                    <meta name="twitter:title"
                          content={`euBines.com ${location && location.city ? location.city : 'United Kingdom'} | Free Classifieds Ads and Offers`}/>
                </Helmet>
                <div id="container" className="container">
                    <div id="content">
                        <div id="form-bg">
                            <div id="form-overlay">
                                <div className="row">
                                    <div className=" col-md-8 col-lg-8" id="iconform">
                                        <input type="text" className="form-control" id="location"
                                               onKeyPress={this._handleKeyPress}
                                               placeholder="All Europe"/>
                                        <i className="fa fa-map-marker-alt"/>
                                    </div>

                                    {/*<div className="col-md-2  col-lg-2">*/}
                                    {/*    <button type="button" className="btn btn-outline-primary" id="search-btn">*/}
                                    {/*        <i className="fa fa-search"/>*/}
                                    {/*        Search*/}
                                    {/*    </button>*/}
                                    {/*</div>*/}

                                </div>

                            </div>

                        </div>
                        <div id="main-content" className="row">
                            <div id="category" className="col p-4">
                                {
                                    this.state.category.map((item, i) => {
                                        return (
                                            <NavLink to={`/${item.cate}/listing`} key={item.cate}>
                                                <div id="cate-item">
                                                    <img src={item.ic} alt={item.cate} height="50" width="50"/>
                                                    <p>{item.cate}</p>
                                                </div>
                                            </NavLink>
                                        );

                                    })
                                }
                            </div>
                        </div>
                    </div>
                    {
                        trending && trending.length > 0 &&
                        <div
                            style={{flex: 1}}
                            className="container-fluid py-4"
                            // className={classes.root}
                        >
                            <h3>Trending {location && location.city ? <span>in <b>{location.city}</b></span> :
                                <span>in <b>United Kingdom</b></span>}
                            </h3>
                            <hr/>
                            <GridList style={{flexWrap: 'nowrap'}} cols={2.5}>
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                // classes={{
                                                //     // root: classes.titleBar,
                                                //     title: {color: 'white'},
                                                // }}
                                                // title
                                                // className={}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                // classes={{
                                                //     // root: classes.titleBar,
                                                //     title: {color: 'white'},
                                                // }}
                                                // title
                                                // className={}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                // classes={{
                                                //     // root: classes.titleBar,
                                                //     title: {color: 'white'},
                                                // }}
                                                // title
                                                // className={}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                // classes={{
                                                //     // root: classes.titleBar,
                                                //     title: {color: 'white'},
                                                // }}
                                                // title
                                                // className={}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                                {trending.map((item, index) => (
                                    <GridListTile key={index}>
                                        <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/${item.photo[0]}`}
                                             alt={item.title}/>
                                        <NavLink
                                            to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}>
                                            <GridListTileBar
                                                title={item.title.toUpperCase()}
                                                // classes={{
                                                //     // root: classes.titleBar,
                                                //     title: {color: 'white'},
                                                // }}
                                                // title
                                                // className={}
                                                subtitle={`£${item.price}`}
                                            />
                                        </NavLink>
                                    </GridListTile>
                                ))}
                            </GridList>
                        </div>
                    }
                    <Box height="small" width="xlarge" overflow="hidden" pad="small" fill>
                        <Carousel fill>
                            {/*<Box pad="large" align="center" style={{*/}
                            {/*    background: 'brown'*/}
                            {/*}}>*/}
                            {/*    <div className="justify-content-center p-3">*/}
                            {/*        <Text>Sell and Buy used or new products.</Text>*/}
                            {/*    </div>*/}
                            {/*</Box>*/}
                            {/*<Box pad="large" align="center" tyle={{*/}
                            {/*    background: 'brown'*/}
                            {/*}}>*/}
                            {/*    <div className="justify-content-center p-3">*/}
                            {/*        <Text>We follow up the best deals and offers for you.</Text>*/}
                            {/*    </div>*/}
                            {/*</Box>*/}
                            <Box pad="large" background="accent-1" fill>
                                <div className="justify-content-center">
                                    <Text alignSelf="center" size="xlarge">Sell and buy used products or new
                                        ones.</Text>
                                    <Deploy/>
                                </div>
                            </Box>
                            <Box pad="large" background="accent-2" fill>
                                <div className="justify-content-center">
                                    <Text alignSelf="center" size="xlarge">We keep track of the best deals and offers
                                        for you.</Text>
                                </div>
                            </Box>
                            <Box pad="large" background="accent-3" fill>
                                <div className="justify-content-center">
                                    <Text alignSelf="center" size="xlarge" pad="small">Post an ad to reach all
                                        channels.</Text>
                                </div>
                            </Box>
                        </Carousel>
                    </Box>
                    <hr/>
                    <AlibabaAds/>
                    <hr/>
                    <AmazonAds/>

                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    setLocation: (location) => dispatch(setCurrentLocation(location))
})
const mapStateToProps = (state) => ({
    location: state.Settings
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/components/Home.js